<ng-container content>
    <div class="list-container">
        <lib-text-snippets-list-component
            (addNewTextSnippetClicked)="openTextSnippetDialog()"
        ></lib-text-snippets-list-component>
    </div>
</ng-container>
